<template lang="pug">
  div.faq
    router-view
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'Faq',
  data(){
    return{
    }
  },
  methods:{
    
  },
  computed:{
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
.faq{
  
}
</style>